module.exports = __webpack_public_path__ + "static/media/pwa.71408db7.png";